import { CmsKfi } from '@/service';

/**
 * @class @name Content
 * @description Exposes menu store module
 */
export default class Kfi {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {
			count: 0
		};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {
			/**
			 * @name setCount
			 * @param {Object} state
			 * @param {Object} data
			 */
			setCount(state, data) {
				state.count = data?.value?.kfiSubmissionCount || 0;
			}
		};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name fetchCount
			 * @param {function} commit
			 */
			async fetchCount({ commit }) {
				const { data } = await CmsKfi.get('submissions');
				commit('setCount', data);
			}
		};
	}
}
